import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { DateTime } from 'luxon';

import {
  downloadInvoice,
  resetPayment,
  resetUrlInvoice
} from '../../../store/actions';
import { getCustomer } from '../../../utils/helpers';

import Loader from '../../../assets/components/loader';

import MarquetCards from '../../../utils/components/MarquetCards';

import CreditCard from '../../../assets/svg/creditCard';


const Invoice = () => {

  const customerId = getCustomer();
  const dispatch = useDispatch();
  const invoiceInfo = useSelector((state) => state.invoice);
  const navigate = useNavigate();

  const [billingCicle, setBillingCicle] = useState("")
  const [totals, setTotals] = useState({
    subTotal: "",
    tax: "",
    total: ""
  })

  useEffect(() => {
    if (customerId === "") {
      navigate('/')
    }
  }, [])

  useEffect(() => {
    if (invoiceInfo.loadedFirstTime){
      dispatch(resetPayment());
    }
  }, [invoiceInfo.loadedFirstTime])

  useEffect(() => {
    if (Object.keys(invoiceInfo.subscription).length === 0) {
      navigate(`/mySubscriptions`)
    }
  }, [invoiceInfo.subscription])

  useEffect(()=>{
    if (invoiceInfo && invoiceInfo.subscription && invoiceInfo.subscription.billingPeriodUnit){
      if (invoiceInfo.subscription.billingPeriodUnit === "month"){
        setBillingCicle("Monthly")
      } else if (invoiceInfo.subscription.billingPeriodUnit === "year"){
        setBillingCicle("Annually")
      }
    }

    let subTotal = 0;
    let tax = 0;
    let total = 0;
    if (invoiceInfo && invoiceInfo.subscription && invoiceInfo.user){
      invoiceInfo.subscription.subscriptionItems.map((item) => {
        subTotal += (item.quantity * item.unitPrice)
        total += (item.quantity * item.unitPrice)
      })
      if (invoiceInfo.user.billingAddress.country === "CA") {
        tax = (subTotal * 0.13)
        total += (subTotal * 0.13)
      }
      setTotals({
        subTotal: (subTotal / 100).toLocaleString('en-US', { style: 'currency', currency: invoiceInfo.subscription.currencyCode }),
        tax: (tax / 100).toLocaleString('en-US', { style: 'currency', currency: invoiceInfo.subscription.currencyCode }),
        total: (total / 100).toLocaleString('en-US', { style: 'currency', currency: invoiceInfo.subscription.currencyCode })
      })
    }
  }, [invoiceInfo])

  function formatDate(timestamp) {
    const date = DateTime.fromSeconds(timestamp);
    const formattedDate = date.toFormat("MMMM dd, yyyy");
    return formattedDate;
  }

  useEffect(() => {
    if (invoiceInfo.downloadUrl !== "") {
      const link = document.createElement('a');
      link.href = invoiceInfo.downloadUrl;
      link.setAttribute(
        'download',
        `invoice${invoiceInfo.downloadUrl}.pdf`,
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      dispatch(resetUrlInvoice());
    }
  }, [invoiceInfo.downloadUrl])

  return (
    <>
      <div className="marquet--invoice">
        <div className="invoice--column">
          <MarquetCards classStyles={"profile--card"}>
            <div className="top--card--title">
              <span>Your Profile</span>
            </div>
            <div>
              <h4 className="marquet--colored">
                {`${invoiceInfo.user.firstName} ${invoiceInfo.user.lastName}`}
              </h4>
            </div>
            <div>
              <h3 className="company--name">
                {`${invoiceInfo.user.company}`}
              </h3>
            </div>
            <div className="user--info">
              <div>
                <h5>Address</h5>
                <span>
                  {`${invoiceInfo.user.billingAddress.line1} ${invoiceInfo.user.billingAddress.city}, ${invoiceInfo.user.billingAddress.state}, ${invoiceInfo.user.billingAddress.country}`}
                </span>
              </div>
            </div>
            <div className="user--info">
              <div>
                <h5>Phone</h5>
                <span>
                  {`${invoiceInfo.user.billingAddress.phone}`}
                </span>
              </div>
            </div>
            <div className="user--info">
              <div>
                <h5>Email</h5>
                <span>
                  {`${invoiceInfo.user.billingAddress.email}`}
                </span>
              </div>
            </div>
          </MarquetCards>
        </div>
        <div className="invoice--column">
          <MarquetCards classStyles={"subscription--card"}>
            <div className="top--card--title">
              <span>Your Plan</span>
              <a type="button" onClick={ev => { navigate(`/mySubscription/${invoiceInfo.subscription.id}`)}} className="custom--link">upgrade</a>
            </div>
            <div>
              <h4 className="marquet--colored">
                {`${formatDate(invoiceInfo.subscription.startedAt)} - ${formatDate(invoiceInfo.subscription.nextBillingAt)}`}
              </h4>
            </div>
            <div>
              <h5>
                {`Next Invoice: ${formatDate(invoiceInfo.subscription.nextBillingAt)}`}
              </h5>
            </div>
            <div>
              <h3>
                {invoiceInfo.invoice.lineItems[0].description}
              </h3>
            </div>
            <div className="item--price">
              <div>
                <h4>Subscription Fee</h4>
                <i></i>
                <span>
                  {`${(invoiceInfo.subscription.subscriptionItems[0].unitPrice/100).toLocaleString('en-US', { style: 'currency', currency: invoiceInfo.subscription.currencyCode })}`}
                </span>
              </div>
              <div className="subscription--frecuency">
                {`Billed ${billingCicle}`}
              </div>
            </div>
            <div className="subscription--details">
              {invoiceInfo.invoice && invoiceInfo.invoice.lineItems && invoiceInfo.invoice.lineItems.length > 1 &&
                <div>
                  <h4>Add-ons</h4>
                </div>
              }
              {invoiceInfo.invoice && invoiceInfo.invoice.lineItems && invoiceInfo.invoice.lineItems.length > 1 &&
                invoiceInfo.invoice.lineItems.map((it, i) => {
                  if(i > 0){
                    return(
                      <div key={i} className="item--price">
                        <div>
                          <h5>{`${it.quantity} ${it.description}`}</h5>
                          <i></i>
                          <span>
                            {`${((it.quantity * it.unitAmount)/100).toLocaleString('en-US', { style: 'currency', currency: invoiceInfo.subscription.currencyCode }) }`}
                          </span>
                        </div>
                        <div className="subscription--frecuency">
                          {`Billed ${billingCicle}`}
                        </div>
                      </div>
                    )
                  }
                })
              }
              <div className="item--price">
                <div>
                  <h4>SUB-TOTAL</h4>
                  <i></i>
                  <span>
                    {totals.subTotal}
                  </span>
                </div>
              </div>
              <div className="item--price">
                <div>
                  <h4>TAX</h4>
                  <i></i>
                  <span>
                    {totals.tax}
                  </span>
                </div>
              </div>
              <div className="item--price">
                <div>
                  <h4>TOTAL</h4>
                  <i></i>
                  <span>
                    {totals.total}
                  </span>
                </div>
              </div>
            </div>
            <div className="centered--row">
              {invoiceInfo.loading ?
                <>
                  <Loader size="xs" />
                  <a type="button" className="custom--link">Download Invoice</a>
                </>
                :
                <a onClick={ev => { dispatch(downloadInvoice(invoiceInfo.invoice.id))}} type="button" className="custom--link">Download Invoice</a>
              }
            </div>
          </MarquetCards>
        </div>
        <div className="invoice--column">
          <MarquetCards>
            <div className="top--card--title">
              <span>Payment Method</span>
            </div>
            <div className="card--icon--container">
              <CreditCard
                type={invoiceInfo.card.cardType}
                cardNumber={invoiceInfo.card.maskedNumber}
                expirationDate={`${invoiceInfo.card.expiryMonth}/${invoiceInfo.card.expiryYear.toString().slice(-2)}`}
              />
            </div>
            <div>
              <span>
                {invoiceInfo.card.cardType}
              </span>
            </div>
            <div>
              <span>{`Credit Card Ending in ${invoiceInfo.card.maskedNumber}`}</span>
            </div>
          </MarquetCards>
        </div>
        <div className="marquet--button--group">
          <button
            className="custom--button custom--button--marquet"
            onClick={ev => { navigate(`/createVirtualSpace/${invoiceInfo.subscription.id}`)}}>
            Continue to create your Marquet virtual space
          </button>
        </div>
      </div>
    </>
  )
}

export default Invoice;